import { baggagesLib } from './baggages';
import { priceLib } from './price';

export const mappedPassengersLib = {
  ...baggagesLib,
  ...priceLib,
};
